import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  initialValue?: string;
  size?: "sm" | "md" | "lg";
  placeholder?: string;
  className?: string;
}

export default function SearchBar({
  initialValue = "",
  size = "md",
  placeholder = "搜索影视作品、演员、资讯",
  className = "",
}: SearchBarProps) {
  const navigate = useNavigate();
  const [value, setValue] = useState(initialValue);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const height = size === "lg" ? "h-12" : size === "sm" ? "h-9" : "h-10";
  const text = size === "lg" ? "text-base" : "text-sm";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex items-center gap-2 w-full ${className}`}
    >
      <div className="relative flex-1">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
          <i className="ri-search-line text-base" />
        </span>
        <input
          type="search"
          name="q"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          aria-label="站内搜索"
          className={`w-full ${height} ${text} pl-10 pr-3 rounded-md bg-background-50 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors`}
        />
      </div>
      <button
        type="submit"
        className={`${height} px-4 rounded-md bg-primary-500 text-background-50 ${text} whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors`}
      >
        搜索
      </button>
    </form>
  );
}